// Author : Vishnu
//Version :0.0.1
// MODIFIED DATE: 04/8/2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** ADD GROUP DETAILS START *********************** */
export const groupDetailsAdd = (addData: any) => {
	const data = {
		AddGroupDetailsToken: addData,
	};

	const url = `${API_URL}addGroupDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD GROUP DETAILS END *********************** */

/** ***************** GET GROUP LIST START *********************** */
export const groupListGet = (listData: any) => {
	const data = {
		GetAllGroupListToken: listData,
	};
	const url = `${API_URL}getGroupListWithPaginaionToken`;
	return makeApiCall(url, data);
};
/** ***************** GET GROUP LIST END *********************** */

/** ***************** FETCH ALL GROUP START *********************** */
export const allGroupFetch = (fetchGroupData: any) => {
	const data = {
		FetchAllGroupKeyToken: fetchGroupData,
	};
	const url = `${API_URL}getAllGroupOnLocation`;
	return makeApiCall(url, data);
};
/** ***************** FETCH ALL GROUP END *********************** */

/** ***************** FETCH ALL APPROVED MEMBER START *********************** */
export const allApprovedMemberFetch = (fetchApprovedMemberData: any) => {
	const data = {
		FetchApprovedMembersToken: fetchApprovedMemberData,
	};
	const url = `${API_URL}getAllApproveMemberNotInGroup`;
	return makeApiCall(url, data);
};
/** ***************** FETCH ALL APPROVED MEMBER END *********************** */

/** ***************** GET ALL OFFICER LIST START *********************** */
export const allOfficerGet = (listData: any) => {
	const data = {
		GetAllOfficerListToken: listData,
	};
	const url = `${API_URL}getAllOfficerUserBaseOnLevel`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL OFFICER LIST END *********************** */

/** ***************** GET ALL GROUP DETAILS START *********************** */
export const allGroupDetailsGet = (listData: any) => {
	const data = {
		GetAllGroupKeyToken: listData,
	};

	const url = `${API_URL}getGroupDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL GROUP DETAILS END *********************** */

/** ***************** GET BRANCH OFFICER LIST START *********************** */
export const branchOfficerListGet = (listData: any) => {
	const data = {
		BranchOfficerListToken: listData,
	};

	const url = `${API_URL}getAllOfficerUserBasedonCompany`;
	return makeApiCall(url, data);
};
/** ***************** GET BRANCH OFFICER LIST END *********************** */

/** ***************** UPDATE EXIST GROUP START *********************** */
export const updateGroup = (listData: any) => {
	const data = {
		UpdateGroupData: listData,
	};
	const url = `${API_URL}updateGroupDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE EXIST GROUP END *********************** */

/** ***************** REMOVE MEMBER FROM GROUP START *********************** */
export const deleteRemoveMemberFromGroup = (listData: any) => {
	const data = {
		RemoveMemberfromGroupData: listData,
	};
	const url = `${API_URL}deleteRemoveMemberFromGroup`;
	return makeApiCall(url, data);
};
/** ***************** REMOVE MEMBER FROM GROUP END *********************** */

/** ***************** DELETE GROUP START *********************** */
export const deleteGroup = (listData: any) => {
	const data = {
		DeleteExistGroupData: listData,
	};
	const url = `${API_URL}deleteGroupDetails`;
	return makeApiCall(url, data);
};
/** ***************** DELETE GROUP END *********************** */
